import { useState, useEffect, useRef, useCallback } from 'react';
import styles from '../css/ticketEntry.module.css';
import { serverURL } from '../helpers/dataServerURL';
import axios from 'axios';
import Modal from '../components/Modal';
import CarMakes from './carMakes';
import CarsColors from './carsColors';
import { useLocation } from 'react-router-dom';
import LocationEntry from './locate';
import FooterPage from './footerPage';
import HeroTicketEntry from './hero';
import { useNavigate } from 'react-router-dom';
import TicketEntryPage from '../components/TicketEntryPage';
import AssignLocation from '../components/AssignLocation';
import CarInfo from '../components/CarInfo';
import { Slide, toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaPlusCircle, FaExchangeAlt } from 'react-icons/fa';
import { IoMdExit } from 'react-icons/io';
import { insertUnCheckedInTickets } from '../helpers/databaseAPI';
import { convertToDatabaseDateTime } from '../helpers/timeDifference';
import { findOmittedTicket, deleteMovedTicket } from '../helpers/databaseAPI';

export default function TicketHeroPage() {
  const [sectionName, setSectionName] = useState('');
  const [laneNumber, setLaneNumber] = useState('');
  const [spotNumber, setSpotNumber] = useState('');

  const [ticket, setTicket] = useState('');
  const [locator, setLocator] = useState('');
  const [carMake, setCarMake] = useState('');
  const [carColor, setCarColor] = useState('');
  const [licensePlate, setLicensePlate] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [isCarMakeOpen, setIsCarMakeOpen] = useState(false);
  const [isCarColorOpen, setIsCarColorOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteTicket, setDeleteTicket] = useState(false);

  const logInURL = serverURL.server.url;
  const { state } = useLocation();
  const location = useLocation();
  const navigate = useNavigate();

  const ticketRef = useRef(null);
  const locatorRef = useRef(null);
  const carMakeRef = useRef(null);
  const sectionRef = useRef(null);
  const laneRef = useRef(null);
  const spotRef = useRef(null);

  useEffect(() => {
    if (state?.selectedCarMake) {
      setCarMake(state.selectedCarMake);
    }
    if (state?.selectedCarColor) {
      setCarColor(state?.selectedCarColor);
    }
    if (state?.selectedSection) {
      setSectionName(state?.selectedSection);
    }
    if (state?.frequentCar) {
      setCarMake(state?.frequentCar);
    }
    if (state?.targetTicket) {
      setTicket(state?.targetTicket);
      fetchTickets(state?.targetTicket);
    }

    if (state?.targetLocator) {
      setTicket(state?.targetLocator);
      fetchTickets(state?.targetLocator);
    }

    if (state?.newTicket) {
      setTicket(state?.newTicket);
    }
    // ticketRef.current.focus();
    locatorRef.current.focus();
  }, [state]);

  useEffect(() => {
    if (state?.selectedLane) {
      setLaneNumber(state?.selectedLane);
    }
  }, [state]);

  useEffect(() => {
    if (state?.selectedSpot) {
      setSpotNumber(state?.selectedSpot);
    }
  }, [state]);

  useEffect(() => {
    console.log(location.state.deleteTicket, 'state delete ticket');
    if (state?.deleteTicket) {
      setDeleteTicket(true);
    }
  }, [state]);

  // Handle ticket submission. Posts ticket data to server including car and location info.
  async function handleSubmit() {
    // e.preventDefault();
    // handle ticket submission logic here

    try {
      const response = await axios.post(`${logInURL}/daily/addTicket`, {
        SectionName: sectionName,
        LaneNum: laneNumber,
        SpaceNum: spotNumber,
        Ticket: ticket,
        Locator: locator,
        CarMake: carMake,
        CarColor: carColor,
        LicensePlate: licensePlate,
      });
      console.log('Ticket submitted successfully:', response.data);
    } catch (error) {
      console.error('Error submitting ticket:', error);
    }
  }

  async function postTicketLocation() {
    try {
      const response = await axios.post(`${logInURL}/spaces/addCarLocation`, {
        SectionName: sectionName,
        LaneNum: laneNumber,
        SpaceNum: spotNumber,
        Occupied: true,
        Ticket: ticket,
        Locator: locator,
      });
      console.log('Ticket location posted successfully:', response.data);
    } catch (error) {
      console.error('Error posting ticket location:', error);
    }
  }

  function clearEntries() {
    setTicket('');
    setLocator('');
    setCarMake('');
    setCarColor('');
    setLicensePlate('');
    setSectionName('');
    setLaneNumber('');
    setSpotNumber('');
  }

  const fetchTickets = useCallback(
    async (ticketNumber) => {
      try {
        const response = await axios.get(`${logInURL}/daily/enteredTicket/${ticketNumber}`);

        if (response.data.length > 0) {
          setIsEditMode(true);
          setCarMake(response.data[0]?.CarMake);
          setCarColor(response.data[0]?.CarColor);
          setLicensePlate(response.data[0]?.LicensePlate);
          setSectionName(response.data[0]?.SectionName);
          setLaneNumber(response.data[0]?.LaneNum);
          setSpotNumber(response.data[0]?.SpaceNum);
          setLocator(response.data[0]?.Locator);
        } else {
          console.log('No ticket found');
          setIsEditMode(false);
        }
      } catch (error) {
        console.error('Error fetching ticket:', error);
      }
    },
    [logInURL],
  );

  // TODO: Implement locator ticket fetching logic.
  // This function should retrieve the locator ticket data and update the state accordingly.
  function fetchLocator() {}

  async function updateTicketLocation() {
    try {
      const response = await axios.patch(`${logInURL}/spaces/updateCarLocation`, {
        SectionName: sectionName,
        LaneNum: laneNumber,
        SpaceNum: spotNumber,
        Ticket: ticket,
      });
      if (response.status === 200) {
        console.log('Ticket location updated successfully:', response.data);
      }
    } catch (error) {
      console.error('Error updating ticket location:', error);
    }
  }
  async function updateTicket() {
    try {
      const response = await axios.patch(`${logInURL}/daily/updateTicket`, {
        SectionName: sectionName,
        LaneNum: laneNumber,
        SpaceNum: spotNumber,
        CarMake: carMake,
        CarColor: carColor,
        LicensePlate: licensePlate,
        Ticket: ticket,
      });
      if (response.status === 200) {
        console.log('Ticket updated successfully:');
        updateTicketLocation();
        setIsEditMode(false);
      }
      if (response.data.affectedRows === 0) {
        toast.error(
          <div>
            <h3>Update Error</h3>
            <p>No matching ticket found to update.</p>
          </div>,
        );
      }
    } catch (error) {
      console.error('Error updating ticket:', error);
    }
  }

  function validateInput() {
    // Add input validation logic here
    if (!ticket) {
      toast.error(
        <div>
          <h3>Entry Error</h3>
          <p>Please enter a ticket number.</p>
        </div>,
      );
      handleFocus();
      return false;
    }

    if (!locator) {
      toast.error(
        <div>
          <h3>Entry Error</h3>
          <p>Please enter a locator ticket number.</p>
        </div>,
      );
      handleFocus();
      return false;
    }

    if (!carMake) {
      toast.error(
        <div>
          <h3>Entry Error</h3>
          <p>Please enter a car make.</p>
        </div>,
      );
      handleFocus();
      return false;
    }
    if (!sectionName) {
      toast.error(
        <div>
          <h3>Entry Error</h3>
          <p>Please select a section.</p>
        </div>,
      );
      handleFocus();
      return false;
    }
    if (!laneNumber) {
      toast.error(
        <div>
          <h3>Entry Error</h3>
          <p>Please enter a lane number.</p>
        </div>,
      );
      handleFocus();
      return false;
    }
    if (!spotNumber) {
      toast.error(
        <div>
          <h3>Entry Error</h3>
          <p>Please enter a spot number.</p>
        </div>,
      );
      handleFocus();
      return false;
    }
    return true;
  }

  function handleFocus() {
    if (!ticket) {
      ticketRef.current.focus();
      return;
    }

    // if (!locator) {
    //   locatorRef.current.focus();
    //   return;
    // }

    if (!carMake) {
      carMakeRef.current.focus();
      return;
    }

    if (!sectionName) {
      sectionRef.current.focus();
      return;
    }
    if (!laneNumber) {
      laneRef.current.focus();
      return;
    }
    if (!spotNumber) {
      spotRef.current.focus();
      return;
    }
  }

  return (
    <div className={styles.topContainer}>
      <ToastContainer position="top-center" autoClose={3000} closeOnClick={true} transition={Slide} />
      <HeroTicketEntry
        openCheckOut={() => {
          navigate('/checkOutScreen', {
            state: {
              openCheckOut: true,
            },
          });
        }}
        btnIcon=<IoMdExit
          style={{
            marginRight: '5px',
            top: '5px',
            position: 'relative',
          }}
          size={'24px'}
        />
        btnCaption="Check Out"
        title="Ticket Entry Portal"
        isBtnVisible={false}
        uncheckedInTickets={async () => {
          console.log(await findOmittedTicket(logInURL, ticket));
          if ((await findOmittedTicket(logInURL, ticket)) === false) {
            console.log(ticket, 'Ticket does not exist');
            ticket && (await insertUnCheckedInTickets(logInURL, ticket, convertToDatabaseDateTime(new Date())));
          } else {
            console.log('Ticket does exist');
          }
        }}
      />
      <div>
        {/* Ticket Entry Card */}
        <div className={styles.cardContainer}>
          <label
            htmlFor="ticket"
            style={{
              fontSize: '16px',
              fontWeight: 'bold',
              marginTop: '15px',
            }}
          >
            Add/Edit Ticket, Car and Location information
          </label>
          <TicketEntryPage
            tkt={ticket}
            tktRef={ticketRef}
            locatorRef={locatorRef}
            inputChange={(e) => {
              setTicket(e.target.value);
            }}
            locator={locator}
            locatorChange={(e) => {
              setLocator(e.target.value);
            }}
            pullLocator={fetchLocator}
            pullTicket={fetchTickets}
            clearInput={() => {
              // clearEntries();
            }}
          />
          <AssignLocation
            setSection={setSectionName}
            section={sectionName}
            lane={laneNumber}
            setLane={setLaneNumber}
            setSpot={setSpotNumber}
            spot={spotNumber}
            sectionRef={sectionRef}
            laneRef={laneRef}
            spotRef={spotRef}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />
          <CarInfo
            make={carMake}
            freqMake={carMake}
            color={carColor}
            license={licensePlate}
            setMake={setCarMake}
            setFreqMake={setCarMake}
            setColor={setCarColor}
            setLicense={setLicensePlate}
            isCarMakeOpen={isCarMakeOpen}
            setIsCarMakeOpen={setIsCarMakeOpen}
            setIsCarColorOpen={setIsCarColorOpen}
            makeRef={carMakeRef}
          />

          <div className={styles.buttonGroup}>
            <button
              className={styles.scanButton}
              onClick={async () => {
                if (validateInput() === false) {
                  return;
                }
                if (isEditMode === true) {
                  updateTicket();
                  console.log(deleteTicket, 'Delete ticket');
                  if (deleteTicket) {
                    await deleteMovedTicket(logInURL, ticket);
                  }
                  navigate('/');
                } else {
                  handleSubmit();
                  postTicketLocation();
                  navigate('/');
                }
                clearEntries();
                // navigate('/', { state: { changedTkt: ticket } });
              }}
              type="button"
            >
              {isEditMode ? (
                <>
                  <FaExchangeAlt
                    style={{
                      marginRight: '10px',
                      top: '7px',
                      position: 'relative',
                    }}
                    size={'24px'}
                  />
                  Update Ticket
                </>
              ) : (
                <>
                  <FaPlusCircle
                    style={{
                      position: 'relative',
                      top: '7px',
                      marginRight: '10px',
                    }}
                    size={'24px'}
                  />{' '}
                  Submit Ticket
                </>
              )}
            </button>
          </div>
        </div>
        <div className={styles.outerContainer}>
          <div>
            <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
              <LocationEntry closeModal={() => setIsOpen(false)} />
            </Modal>
            <Modal
              isOpen={isCarMakeOpen}
              onClose={() => {
                setIsCarMakeOpen(false);
                console.log('Car make closed', carMake);
              }}
            >
              <CarMakes selectedCarMake={carMake} closeScreen={() => setIsCarMakeOpen(false)} />
            </Modal>
            <Modal isOpen={isCarColorOpen} onClose={() => setIsCarColorOpen(false)}>
              <CarsColors
                closeScreen={() => {
                  setIsCarColorOpen(false);
                }}
              />
            </Modal>
          </div>
        </div>
      </div>
      <div style={{ position: 'fixed', bottom: '10px' }}>
        <FooterPage />
      </div>
    </div>
  );
}
